module.exports = __webpack_public_path__ + "media/img/feature2-00c7b61cccdd66713dd3d58982f01fc0.svg";